export const FEATUREHUB_EDGE_URL = 'https://edge.featurehub.bpglobal.com/';

const FLAGS = {
    ForgeRockEnabled: 'enableForgeRockLogin',
    showPortalUnderMaintenance: 'showPortalUnderMaintenance'
  }

  export default FLAGS